export default __webpack_public_path__ + "static/media/off-icon.4a2ee775.svg";